exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Pill {\n  display: inline-block;\n  border-radius: 16px;\n  padding: 0 10px 1px 9px;\n  font-size: 11px;\n  line-height: 15px;\n}\n", ""]);

